import * as types from './types'
import {
  APP_BUSINESS_PARTNER_ROLE_PNC,
  APP_BUSINESS_PARTNER_ROLE_PNH,
  APP_BUSINESS_PARTNER_ROLE_PNP,
  APP_BUSINESS_PARTNER_ROLE_APRENDIZ,
  APP_BUSINESS_PARTNER_ROLE_FOCADO,
  APP_BUSINESS_PARTNER_ROLE_PROTAGONISTA,
  APP_BUSINESS_PARTNER_ROLE_CAMPEAO,
  APP_EMPLOYEE_PN_ROLE_ID,
  APP_ADMIN_ROLE_ID
} from '@/constants/auth'

export default {
  [types.USER]: state => {
    return state.user
  },
  [types.ABILITIES]: state => {
    return state.abilities
  },
  [types.IS_HUNTER]: state => {
    return state.user.user_role_id === APP_BUSINESS_PARTNER_ROLE_PNH
  },
  [types.IS_CLOSER]: state => {
    return state.user.user_role_id === APP_BUSINESS_PARTNER_ROLE_PNC
  },
  [types.IS_PLANNER]: state => {
    return (state.user.user_role_id === APP_BUSINESS_PARTNER_ROLE_PNP || state.user.user_role_id === APP_BUSINESS_PARTNER_ROLE_APRENDIZ)
  },
  [types.IS_PN]: state => {
    return (
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_PNH ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_PNC ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_APRENDIZ ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_FOCADO ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_PROTAGONISTA ||
      state.user.user_role_id == APP_BUSINESS_PARTNER_ROLE_CAMPEAO ||
      state.user.user_role_id == APP_EMPLOYEE_PN_ROLE_ID
    )
  },
  [types.IS_ADMIN]: state => {
    return state.user.user_role_id == APP_ADMIN_ROLE_ID
  },
  [types.COMPANY_PENDENCIES]: state => {
    return state.company_pendencies
  },
  [types.SYSTEM_VERSION_NOTIFICATIONS]: state => {
    return state.announcement_notifications
  },
  [types.PN_ONBOARDING_STATUS]: state => {
    return state.pn_onboarding_status
  },
  [types.REPORT_LOCK]: state => state.reportLock,
  [types.IS_REPORT_LOCKED]: state => !!(state.reportLock && state.reportLock.locked),
}
